module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "view"
  }, [_c('div', {
    staticClass: "leftbar col-xs-12 col-sm-12 col-md-3 col-lg-3"
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.menu)
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "twitter-timeline",
    attrs: {
      "data-height": "600",
      "href": "https://twitter.com/OSIRIS_CES?ref_src=twsrc%5Etfw"
    }
  }, [_vm._v("Tweets by OSIRIS_CES")]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "center col-xs-12 col-sm-12 col-md-9 col-lg-9"
  }, [_c('div', {
    staticClass: "pagetitle"
  }, [_vm._v("\n        " + _vm._s(_vm.content.id_pagina === '17648' ? '' : _vm.content.title) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "center-content"
  }, [(_vm.legislacao) ? _c('iframe', {
    staticClass: "legislacao",
    attrs: {
      "src": "https://www.ces.uc.pt/osiris/site/api.php/17643/1/get-legislacao"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.content.content)
    }
  }), _vm._v(" "), _vm._l((_vm.photosets), function(photoset) {
    return _c('div', {
      key: photoset.id
    }, [_c('a', {
      attrs: {
        "data-flickr-embed": "true",
        "data-header": "false",
        "data-footer": "true",
        "href": "https://www.flickr.com/photos/157816548@N08/albums/72157690455141446",
        "title": photoset.title._content
      }
    }, [_c('img', {
      attrs: {
        "src": ("https://farm5.staticflickr.com/" + (photoset.server) + "/" + (photoset.primary) + "_" + (photoset.secret) + ".jpg"),
        "width": "500",
        "height": "375",
        "alt": photoset.title._content
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "photoset-title",
      domProps: {
        "innerHTML": _vm._s(photoset.title._content)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "photoset-description",
      domProps: {
        "innerHTML": _vm._s(photoset.description._content)
      }
    })])
  }), _vm._v(" "), (_vm.prj) ? _c('div', {
    staticClass: "project"
  }, [_c('div', {
    staticClass: "project-title"
  }, [(_vm.prj.acronimo) ? _c('span', [_vm._v(" " + _vm._s(_vm.prj.acronimo) + " - ")]) : _vm._e(), _vm._v("\n              " + _vm._s(_vm.prj.titulo) + "\n          ")]), _vm._v(" "), (_vm.prj.data_ext) ? _c('div', {
    staticClass: "project-periodo"
  }, [_vm._v("Período "), _c('br'), _c('br'), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.prj.data_ext))])]) : _vm._e(), _vm._v(" "), (_vm.prj.duracao) ? _c('div', {
    staticClass: "project-duracao"
  }, [_vm._v(" Duração "), _c('br'), _c('br'), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.prj.duracao) + " meses")])]) : _vm._e(), _vm._v(" "), (_vm.prj.resumo) ? _c('div', {
    staticClass: "project-resumo"
  }, [_vm._v(" Resumo\n            "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.prj.resumo)
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.prj.resultados) ? _c('div', {
    staticClass: "project-resultados"
  }, [_vm._v(" Resultados\n            "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.prj.resultados)
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "project-funding"
  }, [_vm._v("\n            Financiamento:\n          ")]), _vm._v(" "), _c('ul', [_c('li', _vm._l((_vm.prj.instituicoes), function(institution, idx) {
    return _c('span', {
      key: idx
    }, [_c('span', [_vm._v(_vm._s(institution.nome))]), (idx < _vm.prj.instituicoes.length - 1) ? _c('span', [_vm._v(", ")]) : _vm._e()])
  }))]), _vm._v(" "), (_vm.prj.parceiros) ? _c('div', {
    staticClass: "project-parceiros"
  }, [_vm._v(" Parceiros\n            "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.prj.parceiros)
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "project-people"
  }, [_vm._v("\n            Investigadoras/es:\n          ")]), _vm._v(" "), _c('ul', [_c('li', _vm._l((_vm.prj.pessoas), function(person, idx) {
    return _c('span', {
      key: idx
    }, [(person.url) ? _c('span', [_c('a', {
      attrs: {
        "href": person.url
      }
    }, [_vm._v(_vm._s(person.assinatura))])]) : _vm._e(), (!person.url) ? _c('span', [_vm._v(_vm._s(person.assinatura))]) : _vm._e(), _c('br')])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "project-keywords"
  }, [_vm._v("\n            Palavras-chave:\n          ")]), _vm._v(" "), _c('ul', [_c('li', _vm._l((_vm.prj.palavras), function(palavra, idx) {
    return _c('span', {
      key: idx
    }, [_c('span', [_vm._v(_vm._s(palavra.palavra))]), (idx < _vm.prj.palavras.length - 1) ? _c('span', [_vm._v(", ")]) : _vm._e()])
  }))])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.projects), function(ano, index) {
    return _c('div', {
      key: index,
      staticClass: "projects"
    }, [_c('div', [_c('div', {
      staticClass: "ano"
    }, [(ano.key === '0') ? _c('span', [_vm._v("\n                Projectos em Curso\n              ")]) : _vm._e(), _vm._v(" "), (ano.key > 0) ? _c('span', [_vm._v("\n                Concluídos em " + _vm._s(ano.key) + "\n              ")]) : _vm._e()]), _vm._v(" "), _vm._l((ano.value), function(prj, index) {
      return _c('div', {
        key: index,
        staticClass: "projects"
      }, [(!prj.data_ext) ? _c('div', [_c('div', {
        staticClass: "projects-title"
      }, [(prj.acronimo) ? _c('span', [_vm._v(" " + _vm._s(prj.acronimo) + " - ")]) : _vm._e(), _vm._v("\n                  " + _vm._s(prj.titulo) + "\n                ")]), _vm._v(" "), _c('div', {
        domProps: {
          "innerHTML": _vm._s(prj.resumo)
        }
      })]) : _c('div', [_c('div', {
        staticClass: "projects-title"
      }, [_c('a', {
        attrs: {
          "href": '?prj=' + prj.id_projecto
        }
      }, [(prj.acronimo) ? _c('span', [_vm._v(" " + _vm._s(prj.acronimo) + " - ")]) : _vm._e(), _vm._v("\n                    " + _vm._s(prj.titulo) + "\n                  ")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._m(1, true), _vm._v(" "), _c('ul', [_c('li', _vm._l((prj.pessoas), function(person, idx) {
        return _c('span', {
          key: idx
        }, [(person.url) ? _c('span', [_c('a', {
          attrs: {
            "href": person.url
          }
        }, [_vm._v(_vm._s(person.assinatura))])]) : _vm._e(), (!person.url) ? _c('span', [_vm._v(_vm._s(person.assinatura))]) : _vm._e(), (idx < prj.pessoas.length - 1) ? _c('span', [_vm._v(", ")]) : _vm._e()])
      }))])]), _vm._v(" "), _c('li', [_vm._m(2, true), _vm._v(" "), _c('ul', [_c('li', _vm._l((prj.instituicoes), function(institution, idx) {
        return _c('span', {
          key: idx
        }, [_c('span', [_vm._v(_vm._s(institution.nome))]), (idx < prj.instituicoes.length - 1) ? _c('span', [_vm._v(", ")]) : _vm._e()])
      }))])]), _vm._v(" "), _c('li', [_vm._m(3, true), _vm._v(" "), _c('ul', [_c('li', [_c('span', [_vm._v(_vm._s(prj.data_ext))])])])]), _vm._v(" "), _c('li', [_vm._m(4, true), _vm._v(" "), _c('ul', [_c('li', _vm._l((prj.palavras), function(palavra, idx) {
        return _c('span', {
          key: idx
        }, [_c('span', [_vm._v(_vm._s(palavra.palavra))]), (idx < prj.palavras.length - 1) ? _c('span', [_vm._v(", ")]) : _vm._e()])
      }))])])])])])
    })], 2)])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "rightbar col-xs-12 col-sm-12 col-md-3 col-lg-3"
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.secondary_menu)
    }
  }), _vm._v(" "), (_vm.content.id_pagina === '17648') ? _c('carousel', {
    staticClass: "carousel",
    attrs: {
      "perPage": 1,
      "autoplay": true
    }
  }, _vm._l((_vm.galeriaDestaques), function(destaque) {
    return _c('slide', {
      key: destaque.id_pagina
    }, [_c('div', {
      domProps: {
        "innerHTML": _vm._s(destaque.texto)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "carousel-titulo"
    }, [_c('div', {
      domProps: {
        "innerHTML": _vm._s(destaque.item_menu)
      }
    }), _vm._v(" "), (destaque.item_menu !== destaque.titulo) ? _c('span', {
      staticClass: "carousel-subtitulo",
      domProps: {
        "innerHTML": _vm._s(destaque.titulo)
      }
    }) : _vm._e()])])
  })) : _vm._e()], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fb-page",
    attrs: {
      "data-href": "https://www.facebook.com/observatoriodorisco/",
      "data-tabs": "timeline",
      "data-width": "",
      "data-height": "",
      "data-small-header": "false",
      "data-adapt-container-width": "true",
      "data-hide-cover": "false",
      "data-show-facepile": "true"
    }
  }, [_c('blockquote', {
    staticClass: "fb-xfbml-parse-ignore",
    attrs: {
      "cite": "https://www.facebook.com/observatoriodorisco/"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://www.facebook.com/observatoriodorisco/"
    }
  }, [_vm._v("OSIRIS")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "projects-people"
  }, [_c('strong', [_vm._v("Investigadoras/es:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "projects-funding"
  }, [_c('strong', [_vm._v("Financiamento:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "projects-time"
  }, [_c('strong', [_vm._v("Período:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "projects-keywords"
  }, [_c('strong', [_vm._v("Palavras-chave:")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8c15c3f8","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Content.vue
// module id = 79
// module chunks = 1